<template>
    <div class="message-box dialog-mask">
        <div class="modal-dialog" data-cy="error-modal">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ $t('error.modal.LOGIN_FAILED.title') }}</h4>
                </div>
                <div class="modal-body">
                    <p>{{ $t('error.modal.LOGIN_FAILED.desc') }}</p>
                </div>
                <div class="modal-footer">
                    <div class="col-xs-6 pull-right">
                        <FormButton
                            id="modalPrimaryButtonId"
                            data-cy="error-modal-close"
                            class="btn-black"
                            :button-click="click"
                            :label="$t('error.modal.LOGIN_FAILED.button')"
                        >
                        </FormButton>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { FormButton } from '@arena/toolkit';
import modalEscMixin from '@/mixins/modalEscMixin';

export default {
    components: {
        FormButton,
    },
    mixins: [modalEscMixin],
    created() {
        this.handleEscCallbackToMixin = this.click;
    },
    methods: {
        click() {
            this.$close(true);
        },
    },
};
</script>
